import React from "react";

import { Row, Col ,Card} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Rewards/Rewards.css";

import RewardsCard from "./RewardsCard.js";


import reward1 from "../../../Imgs/AboutUs/Rewards/reward1.jpg";
import reward2 from "../../../Imgs/AboutUs/Rewards/reward2.jpg";
import reward3 from "../../../Imgs/AboutUs/Rewards/reward3.jpg";
import reward4 from "../../../Imgs/AboutUs/Rewards/reward4.jpg";
import reward5 from "../../../Imgs/AboutUs/Rewards/reward5.jpg";
import reward6 from "../../../Imgs/AboutUs/Rewards/reward6.jpg";
import reward7 from "../../../Imgs/AboutUs/Rewards/reward7.png";
import reward8 from "../../../Imgs/AboutUs/Rewards/reward8.jpg";
import reward9 from "../../../Imgs/AboutUs/Rewards/reward9.jpg";
import reward10 from "../../../Imgs/AboutUs/Rewards/reward10.jpg";
import reward11 from "../../../Imgs/AboutUs/Rewards/reward11.jpg";
import reward12 from "../../../Imgs/AboutUs/Rewards/reward12.jpg";
import reward13 from "../../../Imgs/AboutUs/Rewards/reward13.jpg";
import reward14 from "../../../Imgs/AboutUs/Rewards/reward14.jpg";
import reward15 from "../../../Imgs/AboutUs/Rewards/reward15.jpg";
import reward16 from "../../../Imgs/AboutUs/Rewards/reward16.jpg";
import reward17 from "../../../Imgs/AboutUs/Rewards/reward17.jpg";
import reward18 from "../../../Imgs/AboutUs/Rewards/reward18.jpg";
import reward19 from "../../../Imgs/AboutUs/Rewards/reward19.jpg";
import reward20 from "../../../Imgs/AboutUs/Rewards/reward20.jpg";
import reward21 from "../../../Imgs/AboutUs/Rewards/reward21.jpg";



const rewardCard ={
   borderRadius:"20px",
   boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
   backgroundColor:"#fff",
   opacity:"95%"
}
const rewardDescription1 =(
    <span>
        اجلاس یکصد مدیر شایسته ملی / مرکز همایش های صدا و سیما / تیر ۱۳۹۷
    </span>
)
const rewardDescription2 = (
    <span>
        اجلاس سراسری مدیریت مشتری مداری با رویکرد رضایتمندی مشتری / مرکز همایش های بین المللی صدا و سیما / مهر ۱۳۹۶
    </span>
)
const rewardDescription3 = (
    <span>
        دومین جایزه مسئولیت اجتماعی بنگاه های اقتصادی / مرداد ۱۳۹۷
    </span>
)
const rewardDescription4 = (
    <span>
    مدیر شایسته ملی
    </span>
)
const rewardDescription5 = (
    <span>
       تقدیر شورای هماهنگی مدیران روابط عمومی صنعت بیمه از جناب آقای ابراهیم ایران نژاد
    </span>
)
const rewardDescription6 = (
    <span>
        تقدیرنامه مدیرعامل بیمه ما از آقای ابراهیم ایران نژاد
    </span>
)
const rewardDescription7 = (
    <span>
        تقدیر رئیس  محترم کل بیمه مرکزی از جناب آقای ابراهیم ایران نژاد 
    </span>
)
const rewardDescription8 = (
    <span>
    اعتبارنامه مدیر شایسته ملی / سال ۱۳۹۷
    </span>
)
const rewardDescription9 = (
    <span>
   اجلاس تجلیل از مدیران شایسته ایران ۱۴۰۰
    </span>
)
const rewardDescription10 = (
    <span>
    مهندس ایران نژاد، عضو یکصد مدیر نمونه ملی کشور ۱۴۰۰
    </span>
)
const rewardDescription11 = (
  <span>
    کسب لوح رضایت‌ مندی مشتری توسط ايرانيان پوشش در دوران كرونا در همایش سراسری
    رضایت‌مندی مشتری
  </span>
);
const rewardDescription12 = (
  <span>
کسب لوح تقدیر از کمیسیون اقتصادی مجلس  </span>
);
const rewardDescription13 = (
  <span>
تقدیر عضو هیات عامل و معاون توسعه و نوآوری بیمه مرکزی  </span>
);
const rewardDescription14 = (
  <span>
    تقدیر رییس کل وقت بیمه مرکزی ایران از سامانه نوآوری ایرانیان پوشش (سناپ)
  </span>
);
const rewardDescription15 = (
  <span>
کسب تقدیر نامه از سندیکای بیمه گران ایران  </span>
);
const rewardDescription16 = (
  <span>
قدردانی بیمه دانا از مجموعه ایرانیان پوشش  </span>
);
const rewardDescription17 = (
  <span>
تشکر و قدردانی محمد رضا کشاورز مدیر عامل بیمه دی از جناب آقای ایران نژاد مدیر عامل مجموعه ایرانیان پوشش  </span>
);
const rewardDescription18 = (
  <span>
تقدیر صندوق حوادث طبیعی ساختمان ایران از شرکت ارزیابان ایرانیان پوشش  </span>
);
const rewardDescription19 = (
  <span>
    کسب تقدیر نامه از رضایت عملکردی مجموعه ایرانیان پوشش از همکاری با بیمه ملت
  </span>
);
const rewardDescription20 = (
  <span>
    تقدیر از رسانه خبری مراقب بیمه
  </span>
);
const rewardDescription21 = (
  <span>
    تقدیر رییس کل وقت بیمه مرکزی از رسانه خبری مراقب بیمه
  </span>
);
const RewardsCategory = props => {
     return props.size === "laptopdesktop" ? (
       <div className="rewardBackground">
         <div style={{ paddingTop: "75px" }}>
           <Center>
             <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
               <strong>جوایز و افتخارات</strong>
             </p>
           </Center>
           <Center>
             <Margin top={2}>
               <p className="mainTitleDescription" style={{ color: "#fff" }}>
                 فهرست عناوین کسب شده از سوی ایرانیان پوشش
               </p>
             </Margin>
           </Center>
         </div>
         <Row style={{ marginTop: "100px" }}>
           <Col span={5}></Col>
           <Col span={14}>
             <div style={rewardCard}>
               <Row>
                 <Col span={2}></Col>
                 <Col span={20}>
                   <div style={{ padding: "30px" }}>
                     <p className="textParagraph">
                       مدير عامل ايرانيان پوشش به مناسبت كارآفرين نمونه و حضور
                       فعال و چشمگيري در صنعت بيمه چندين بار مورد تشويق و اهدا
                       جوايز و تنديس زرين قرارگرفته است اين افتخارات شامل تنديس
                       عضو يكصد مدير شايسته ملي كشوري سال٩٧ ، چهره ماندگار ملي
                       سال ٩٦ ، رضايت مندي مشتري سال ٩٨، تنديس مسوليت هاي
                       اجتماعي سال٩٨ و همچنين تقديرنامه از سوي رئیس كل بيمه
                       مركزي، دبير كل سنديكا بيمه گران ، برخي از مديران عامل
                       شركت هاي بيمه، بيمه گذاران حقوقي ، مديركل،فرمانداري،
                       شهرداري، مديريت دانشگاه، نماينده مجلس و شوراي اسلامي و
                       نماينده مقام معظم رهبري و نماينده خبرگان رهبري دريافت
                       نموده است .{" "}
                     </p>
                   </div>
                 </Col>
                 <Col span={2}></Col>
               </Row>
             </div>
           </Col>
           <Col span={5}></Col>
         </Row>
         <Margin top={3}></Margin>
         <Center>
           <Margin top={6}>
             <div>
               <Margin top={3}>
                 <p className="subTitle">
                   <strong>جوایز و افتخارات</strong>
                 </p>
               </Margin>
             </div>
           </Margin>
         </Center>
         <Center>
           <div className="subTitleHR"></div>
         </Center>
         <Margin top={3}></Margin>
         <div style={{ backgroundColor: "#f6f6f6" }}>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
                 <Col span={6}>
                   <RewardsCard
                     img={reward4}
                     description={rewardDescription4}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward3}
                     description={rewardDescription3}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward2}
                     description={rewardDescription2}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward1}
                     description={rewardDescription1}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
                 <Col span={6}>
                   <RewardsCard
                     img={reward8}
                     description={rewardDescription8}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward6}
                     description={rewardDescription6}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward7}
                     description={rewardDescription7}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward5}
                     description={rewardDescription5}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
                 <Col span={6}>
                 <RewardsCard
                     img={reward12}
                     description={rewardDescription12}
                     size="laptopdesktop"
                   /></Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward11}
                     description={rewardDescription11}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward10}
                     description={rewardDescription10}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward9}
                     description={rewardDescription9}
                     size="laptopdesktop"
                   />
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
                 <Col span={6}>
                 <RewardsCard
                     img={reward16}
                     description={rewardDescription16}
                     size="laptopdesktop"
                   /></Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward15}
                     description={rewardDescription15}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward14}
                     description={rewardDescription14}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward13}
                     description={rewardDescription13}
                     size="laptopdesktop"
                   />
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
                 <Col span={6}>
                 <RewardsCard
                     img={reward19}
                     description={rewardDescription19}
                     size="laptopdesktop"
                   /></Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward18}
                     description={rewardDescription18}
                     size="laptopdesktop"
                   />
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward17}
                     description={rewardDescription17}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward17}
                     description={rewardDescription17}
                     size="laptopdesktop"
                   />
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
           <Row>
             <Col span={3}></Col>
             <Col span={18}>
               <Row>
               <Col span={6}></Col>
               <Col span={6}></Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward21}
                     description={rewardDescription21}
                     size="laptopdesktop"
                   />
                   <Margin top={4}></Margin>
                 </Col>
                 <Col span={6}>
                   <RewardsCard
                     img={reward20}
                     description={rewardDescription20}
                     size="laptopdesktop"
                   />
                 </Col>
               </Row>
             </Col>
             <Col span={3}></Col>
           </Row>
         </div>
       </div>
     ) : props.size === "tablet" ? (
       <div className="rewardBackground">
         <div style={{ paddingTop: "100px" }}>
           <Center>
             <p
               className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"
               style={{ color: "#fff" }}
             >
               <strong>جوایز و افتخارات</strong>
             </p>
           </Center>
           <Center>
             <Margin top={2}>
               <p
                 className="mainTitleDescriptionTablet"
                 style={{ color: "#fff" }}
               >
                 فهرست عناوین کسب شده از سوی ایرانیان پوشش
               </p>
             </Margin>
           </Center>
         </div>
         <Row style={{ marginTop: "50px" }}>
           <Col span={3}></Col>
           <Col span={18}>
             <div style={rewardCard}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={22}>
                   <div style={{ padding: "15px" }}>
                     <p className="textParagraphTablet">
                       مدير عامل ايرانيان پوشش به مناسبت كارآفرين نمونه و حضور
                       فعال و چشمگيري در صنعت بيمه چندين بار مورد تشويق و اهدا
                       جوايز و تنديس زرين قرارگرفته است اين افتخارات شامل تنديس
                       عضو يكصد مدير شايسته ملي كشوري سال٩٧ ، چهره ماندگار ملي
                       سال ٩٦ ، رضايت مندي مشتري سال ٩٨، تنديس مسوليت هاي
                       اجتماعي سال٩٨ و همچنين تقديرنامه از سوي رئیس كل بيمه
                       مركزي، دبير كل سنديكا بيمه گران ، برخي از مديران عامل
                       شركت هاي بيمه، بيمه گذاران حقوقي ، مديركل،فرمانداري،
                       شهرداري، مديريت دانشگاه، نماينده مجلس و شوراي اسلامي و
                       نماينده مقام معظم رهبري و نماينده خبرگان رهبري دريافت
                       نموده است .
                     </p>
                   </div>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </div>
           </Col>
           <Col span={3}></Col>
         </Row>
         <Center>
           <Margin top={5}>
             <div>
               <p className="subTitleTablet">
                 <strong>جوایز و افتخارات</strong>
               </p>
             </div>
           </Margin>
         </Center>
         <Center>
           <hr className="subTitleHRTablet" />
         </Center>
         <Margin top={3}></Margin>
         <div style={{ backgroundColor: "#f6f6f6" }}>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward2}
                       description={rewardDescription2}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward1}
                       description={rewardDescription1}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward4}
                       description={rewardDescription4}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward3}
                       description={rewardDescription3}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward6}
                       description={rewardDescription6}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward5}
                       description={rewardDescription5}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward8}
                       description={rewardDescription8}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward7}
                       description={rewardDescription7}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward10}
                       description={rewardDescription10}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward9}
                       description={rewardDescription9}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
           <Row>
             <Col span={2}></Col>
             <Col span={20}>
               <Row>
                 <Col span={1}></Col>
                 <Col span={11}></Col>
                 <Col span={11}>
                   <Center>
                     <RewardsCard
                       img={reward11}
                       description={rewardDescription11}
                       size="tablet"
                     />
                   </Center>
                 </Col>
                 <Col span={1}></Col>
               </Row>
             </Col>
             <Col span={2}></Col>
           </Row>
         </div>
       </div>
     ) : (
       <div className="rewardBackground">
         <div style={{ paddingTop: "50px" }}>
           <Center>
             <p
               className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile"
               style={{ color: "#fff" }}
             >
               <strong>جوایز و افتخارات</strong>
             </p>
           </Center>
           <Center>
             <Margin top={2}>
               <p
                 className="mainTitleDescriptionMobile"
                 style={{ color: "#fff" }}
               >
                 فهرست عناوین کسب شده از سوی ایرانیان پوشش
               </p>
             </Margin>
           </Center>
         </div>
         <Row style={{ marginTop: "25px" }}>
           <Col span={1}></Col>
           <Col span={22}>
             <div style={rewardCard}>
               <Row>
                 <Col span={2}></Col>
                 <Col span={20}>
                   <div style={{ padding: "10px" }}>
                     <p className="textParagraphMobile">
                       مدير عامل ايرانيان پوشش به مناسبت كارآفرين نمونه و حضور
                       فعال و چشمگيري در صنعت بيمه چندين بار مورد تشويق و اهدا
                       جوايز و تنديس زرين قرارگرفته است اين افتخارات شامل تنديس
                       عضو يكصد مدير شايسته ملي كشوري سال٩٧ ، چهره ماندگار ملي
                       سال ٩٦ ، رضايت مندي مشتري سال ٩٨، تنديس مسوليت هاي
                       اجتماعي سال٩٨ و همچنين تقديرنامه از سوي رئیس كل بيمه
                       مركزي، دبير كل سنديكا بيمه گران ، برخي از مديران عامل
                       شركت هاي بيمه، بيمه گذاران حقوقي ، مديركل،فرمانداري،
                       شهرداري، مديريت دانشگاه، نماينده مجلس و شوراي اسلامي و
                       نماينده مقام معظم رهبري و نماينده خبرگان رهبري دريافت
                       نموده است .
                     </p>
                   </div>
                 </Col>
                 <Col span={2}></Col>
               </Row>
             </div>
           </Col>
           <Col span={1}></Col>
         </Row>
         <Center>
           <Margin top={4}>
             <div>
               <p className="subTitleMobile">
                 <strong>جوایز و افتخارات</strong>
               </p>
             </div>
           </Margin>
         </Center>
         <Center>
           <div className="subTitleHRMobile"></div>
         </Center>
         <div style={{ backgroundColor: "#f6f6f6" }}>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward1} description={rewardDescription1} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward2} description={rewardDescription2} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward3} description={rewardDescription3} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward4} description={rewardDescription4} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward5} description={rewardDescription5} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward7} description={rewardDescription7} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward6} description={rewardDescription6} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward8} description={rewardDescription8} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward9} description={rewardDescription9} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward10} description={rewardDescription10} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward11} description={rewardDescription11} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward12} description={rewardDescription12} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward13} description={rewardDescription13} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward14} description={rewardDescription14} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward15} description={rewardDescription15} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward16} description={rewardDescription16} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward17} description={rewardDescription17} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward18} description={rewardDescription18} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward19} description={rewardDescription19} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward20} description={rewardDescription20} />
             </Col>
             <Col span={1}></Col>
           </Row>
           <Row>
             <Col span={1}></Col>
             <Col span={22}>
               <RewardsCard img={reward21} description={rewardDescription21} />
             </Col>
             <Col span={1}></Col>
           </Row>
         </div>
       </div>
     );
};

export default RewardsCategory;
